import ConfirmEmailMessagePage from "./ConfirmEmailMessagePage";

export default ConfirmEmailMessagePage;
